import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var DisabledContext = /*#__PURE__*/React.createContext(false);
export var DisabledContextProvider = function DisabledContextProvider(_ref) {
  var children = _ref.children,
    disabled = _ref.disabled;
  var originDisabled = React.useContext(DisabledContext);
  return /*#__PURE__*/_jsx(DisabledContext.Provider, {
    value: disabled || originDisabled,
    children: children
  });
};
export default DisabledContext;